import { Component, AfterViewInit, OnInit, HostListener, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { BillService } from '../../../../services/accounting/bill.service';
import { NotyService } from '../../../../services/common/noty.service';
import { HttpClientService } from '../../../../services/common/http-client.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-bills-index',
  templateUrl: './bills-index.component.html',
  styleUrls: ['./bills-index.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class BillsIndexComponent implements OnInit, AfterViewInit, OnDestroy {
  Math = Math; // Expose Math for template use

  bills: Array<any> = [];

  count: number;

  downloadCsvUrl: string = "";

  searchParams: any = {
    page: 1,
    per_page: 50,
    reversal: "hide_reversed",
    commit: "search",
    search_bills: true
  }

  searching: boolean = false;

  searchOptions: any = {
    order_by: [],
    order_direction: []
  };

  sidebarMaximized: boolean = true;

  sidebarOpen: boolean = false;

  total: number;

  /**
   * Subscription to router events to catch page changes and matter id changes in the URL
   * @type {Subscription}
   */
  routerEventsSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private billService: BillService,
    private httpClientService: HttpClientService,
    private notyService: NotyService,
    private userService: UserService) {
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.initialize();
    });
  }

  ngOnInit(): void {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.initialize();
  }

  /**
   * Called when component is destroyed
   */
  ngOnDestroy() {
    this.routerEventsSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
    }, 5000);
  }

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
  }

  clearSearch() {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    this.resetParams();
    this.search();
  }

  initialize() {
    this.resetParams();
    Object.assign(this.searchParams, this.route.snapshot.queryParams);
    this.billService.getSearchOptions().then(response_json =>{
      console.log("search options bill index", response_json);
      this.searchOptions = response_json;
      if(this.searchOptions && this.searchOptions.per_page)
        this.searchParams.per_page = this.searchOptions.per_page;
      this.search(null, true);
    });
  }

  resetParams() {
    this.searchParams = {
      page: 1,
      per_page: 50,
      reversal: "hide_reversed",
      commit: "search",
      search_bills: true
    }
  }

  search(pageEvent: any = null, isSearching: boolean | null = false) {
    if (isSearching)
      this.searching = true;
    if (pageEvent) this.searchParams.page = pageEvent.page;
    console.log(this.searchParams);
    this.billService.index(this.searchParams).then(response_json => {
      console.log(" bills array", response_json.bills);
      this.bills = response_json.bills
      this.count = response_json.count
      this.total = response_json.total
      if (isSearching)
        this.searching = false;
      let newPageUrl: string = this.httpClientService.buildNewPageUrl(this.billService.url, this.searchParams);
      this.downloadCsvUrl = newPageUrl.replace("commit=search", "commit=Download%20CSV").replace("bills?", "bills.csv?");
      if(window.location.href != newPageUrl)
        this.httpClientService.setNewPageUrl(newPageUrl);
    }).catch(() =>{
      this.searching = false;
      this.notyService.notify('Error loading bills', 'error');
    })
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }
}